import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27b8c7d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.disableTransitions)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(_ctx.classes),
        style: _normalizeStyle({ backgroundColor: _ctx.color }),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.closable)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              (_ctx.closeIconCustom)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.closeIconCustom,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
                    width: "12",
                    class: "close-custom"
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "el-tag__close el-icon-close",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                  }))
            ]))
          : _createCommentVNode("", true)
      ], 6))
    : (_openBlock(), _createBlock(_Transition, {
        key: 1,
        name: "el-zoom-in-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.classes),
            style: _normalizeStyle({ backgroundColor: _ctx.color }),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
          }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true),
            (_ctx.closable)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: "el-tag__close el-icon-close",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                }))
              : _createCommentVNode("", true)
          ], 6)
        ]),
        _: 3
      }))
}